export default function getPasswordReducer(state = {passwordState: (localStorage.getItem("passwordState") ? JSON.parse(localStorage.getItem("passwordState")) : "")}, action) {
    switch (action.type) {
        case 'GET_PASSWORD':
            return {
                passwordState: action.passwordState
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducer/getpasswordreducer.jsx